// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Stripe from 'components/Stripe/Stripe'

class DonateForm extends React.Component {
	constructor() {
		super()

		this.state = {
			amount: '',
			showStripeModal: false,
			stripeModalAmount: 0,
			stripeModalRecur: true
		}
	}

	handleChangeAmount = ( e ) => {
		this.setState( {
			amount: e.target.value
		} )
	}

	handleDonateButtonTypeClick = ( e ) => {
		e.preventDefault()

		let button = e.currentTarget
		let type = button.getAttribute( 'data-type' )
		let parent = button.parentNode.parentNode.parentNode.parentNode
		let activeButton = parent.querySelector( '.donate-button-type.is-active' )

		if ( activeButton == button ) {
			return
		}

		if ( ! type || ! parent ) {
			return
		}

		button.classList.add( 'is-active' )

		if ( activeButton ) {
			activeButton.classList.remove( 'is-active' )
		}

		if ( 'recur' == type ) {
			parent.classList.add( 'is-recurring' )
			parent.classList.remove( 'is-single' )
		} else {
			parent.classList.add( 'is-single' )
			parent.classList.remove( 'is-recurring' )
		}

		this.setState({
			stripeModalRecur: 'recur' == type
		})
	}

	handleDonateButtonClick = ( e ) => {
		e.preventDefault()

		let amount = e.currentTarget.getAttribute( 'data-amount' )

		this.showDonateForm( amount )
	}

	handleDonateButtonCustomClick = ( e ) => {
		e.preventDefault()

		let { amount } = this.state

		// Round down the amount:
		amount = Math.floor( amount )

		this.setState( {
			amount: amount
		} )

		if ( ! amount ) {
			alert( 'Please enter an amount' )
			return
		}

		this.showDonateForm( amount )
	}

	showDonateForm = ( amount, recur ) => {
		this.setState({
			showStripeModal: true,
			stripeModalAmount: amount
		})
	}

	handleDonateAccept = () => {
		this.setState({
			showStripeModal: false,
			stripeModalAmount: 0
		})
	}

	handleDonateCancel = () => {
		this.setState({
			showStripeModal: false,
			stripeModalAmount: 0
		})
	}

	render() {
		const { contextType } = this.props
		const { amount, showStripeModal, stripeModalAmount, stripeModalRecur } = this.state
		let heading = 'Donate $' + stripeModalAmount + ' to ' + siteData.site_name,
			customInputLabel = 'Enter an amount'

		if ( stripeModalRecur ) {
			heading = 'Donate $' + stripeModalAmount + ' (monthly) to ' + siteData.site_name
			customInputLabel = 'Enter a monthly donation amount'
		}

		return (
			<div className='donate-button-wrap'>
				{ showStripeModal &&
					<Stripe
						amount={ stripeModalAmount }
						recur={ stripeModalRecur }
						heading={ heading }
						acceptText="Confirm"
						accept={ this.handleDonateAccept }
						cancel={ this.handleDonateCancel }
					>
					</Stripe>
				}

				<div className="-eofy">
					<h2>We need your support!</h2>
					<h3>Become a Faith FM Mission Partner and help us reach Australia</h3>

					<p>
						Join the Faith FM EOFY Appeal and help us bring the life-changing good news of Jesus to Australia! Support like yours has transformed lives, and with your help, we can do even more. Donate below today and become a Faith FM Mission partner. Together, let's make a difference!
					</p>
				</div>

				{/* 'eofy' == contextType &&
					<React.Fragment>
						<div className="-eofy">
							<h2>We need your support!</h2>
							<h3>Become a Faith FM Mission Partner and help us reach Australia</h3>

							<p>
								Join the Faith FM EOFY Appeal and help us bring the life-changing good news of Jesus to Australia! Support like yours has transformed lives, and with your help, we can do even more. Donate below today and become a Faith FM Mission partner. Together, let's make a difference!
							</p>
						</div>
					</React.Fragment>
				||
					<React.Fragment>
						<h2>Donate Online</h2>

						<p>
							Faith FM is bringing hope to many lives around Australia. Why not help us make a difference? Every dollar helps. If you would like your donation to go to a specific project area or need, you can add a message in the next pop-up window.
						</p>
					</React.Fragment>
				*/}

				<div className='donate-button is-recurring' data-amount=''>
					<div className='-inner'>
						<div className='-types'>
							<div className='-type-wrap'>
								<div className='-type donate-button-type' data-type='single' onClick={ this.handleDonateButtonTypeClick }>
									<i className="icon-checkmark" aria-hidden="true" />
									Give Once
								</div>
							</div>

							<div className='-type-wrap'>
								<div className='-type donate-button-type is-active' data-type='recur' onClick={ this.handleDonateButtonTypeClick }>
									<i className="icon-checkmark" aria-hidden="true" />
									Give Monthly
								</div>
							</div>
						</div>

						<div className='-amounts -amounts-single'>
							<div className='-amount-wrap'>
								<div className='-amount donate-button-preset' data-amount='50' onClick={ this.handleDonateButtonClick }>
									$50
								</div>
							</div>

							<div className='-amount-wrap'>
								<div className='-amount donate-button-preset' data-amount='100' onClick={ this.handleDonateButtonClick }>
									$100
								</div>
							</div>

							<div className='-amount-wrap'>
								<div className='-amount donate-button-preset' data-amount='365' onClick={ this.handleDonateButtonClick }>
									$365
								</div>
							</div>

							<div className='-amount-wrap'>
								<div className='-amount donate-button-preset' data-amount='1000' onClick={ this.handleDonateButtonClick }>
									$1000
								</div>
							</div>
						</div>

						<div className='-amounts -amounts-recur'>
							<div className='-amount-wrap'>
								<div className='-amount donate-button-preset' data-amount='30' onClick={ this.handleDonateButtonClick }>
									$1-a-day
								</div>
							</div>

							<div className='-amount-wrap'>
								<div className='-amount donate-button-preset' data-amount='50' onClick={ this.handleDonateButtonClick }>
									$50/mo
								</div>
							</div>

							<div className='-amount-wrap'>
								<div className='-amount donate-button-preset' data-amount='100' onClick={ this.handleDonateButtonClick }>
									$100/mo
								</div>
							</div>

							<div className='-amount-wrap'>
								<div className='-amount donate-button-preset' data-amount='500' onClick={ this.handleDonateButtonClick }>
									$500/mo
								</div>
							</div>
						</div>

						<div className='-input'>
							<input type='number' placeholder={ customInputLabel } value={ amount } onChange={ this.handleChangeAmount } />
							<i className='donate-button-custom icon-chevron-right' aria-hidden='true' onClick={ this.handleDonateButtonCustomClick } />
						</div>
					</div>
				</div>

				<div className="-eofy-special">
					<h2>Help us with a once-off tax-deductible gift for special projects</h2>

					<div className="-button">
						<a href="/support" className="button">Special Projects</a>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		offersById: state.page.offersById
	}
}

export default connect( mapStateToProps )( DonateForm )
